require([
	'jquery',
	'root/Base/Js/MbiMediaQuery',
], function(
	$,
	mbiMq
) {
	'use strict';

	if ($('.section-audience-navigation').length) {


		var $gridViewItem = $('.js_change-view').first();

		var view = {
			currentView: $('html').attr('data-view'),
			setView: function(newView){
				this.currentView = newView;
			},
			getView: function(){
				return this.currentView;
			}
		};


		function setActiveView($gridViewItem) {
			if (!$gridViewItem.hasClass('is_active')) {
				var newView = $gridViewItem.attr('data-view');
				$('.nav-view__link').toggleClass('is_active');
				$('html').attr('data-view', newView);
				view.setView(newView);
			}
		}


		$('.js_change-view').click(function(e){
			e.preventDefault();
			e.stopPropagation();

			setActiveView($(this));

		});


		setActiveView($gridViewItem);

		$(document).on('breakpoint', function(){
			if ('lap-' in mbiMq.mqArea) {
				setActiveView($gridViewItem);
			}
		});


	}
});
define("root/Assets/Templates/Html/AudienceNavigation/Js/AudienceNavigation", function(){});

